<template>
  <div class="hcrmhttj">
    <div class="tjheader between">
      <sub-title text="热门合同推荐" />
      <div class="gd">更多></div>
    </div>
    <div class="ttjlist">
      <div class="ttjitem" v-for="item in 5" :key="item">
        <div class="toptxt flex_start ellipsis">
          <div><img src="../../../assets/hotconsult/tjwdicon.png" /></div>
          <div class="w245 ellipsis">劳动争议和解协议书</div> 
        </div>
        <div class="bomtxt between">
          <div class="zctxt">【合同文书】</div>
          <div class="price">￥9.99</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.hcrmhttj {
  .tjheader {
    padding: 26px 0 15px;
    border-bottom: 1px solid #ccc;
    .gd {
      font-size: 14px;
      color: #999999;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .ttjlist {
    padding: 0 20px 0 16px;
    .ttjitem {
      padding: 20px 0;
      width: 100%;
      border-bottom: 1px solid #ccc;
      cursor: pointer;
      .toptxt {
        font-size: 14px;
        color: #333333;
        padding-left: 5px;
        .w245{
        width: 245px;
        }
        img {
          width: 11px;
          height: 13px;
          margin-right: 8px;
        }
      }
      .bomtxt {
        margin-top: 6px;
        font-size: 14px;
        .zctxt {
          color: #999999;
        }
        .price {
          color: #e80100;
        }
      }
      
      &:last-child {
        border-bottom: none;
      }
      &:hover{
        .toptxt{
          color: #0465ea;
        }
      }
    }
  }
}
</style>